// Telegram WebApp API types
declare global {
  interface Window {
    Telegram?: {
      WebApp: TelegramWebApp;
    };
  }
}

interface TelegramWebApp {
  initData: string;
  initDataUnsafe: {
    user?: {
      id: number;
      first_name: string;
      last_name?: string;
      username?: string;
      photo_url?: string;
      language_code?: string;
    };
    start_param?: string;
  };
  colorScheme: 'light' | 'dark';
  themeParams: {
    bg_color?: string;
    text_color?: string;
    button_color?: string;
    button_text_color?: string;
  };
  ready: () => void;
  expand: () => void;
  close: () => void;
  MainButton: {
    text: string;
    color: string;
    textColor: string;
    isVisible: boolean;
    isActive: boolean;
    show: () => void;
    hide: () => void;
    onClick: (callback: () => void) => void;
    offClick: (callback: () => void) => void;
    enable: () => void;
    disable: () => void;
    showProgress: (leaveActive?: boolean) => void;
    hideProgress: () => void;
    setText: (text: string) => void;
  };
  HapticFeedback: {
    impactOccurred: (style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft') => void;
    notificationOccurred: (type: 'error' | 'success' | 'warning') => void;
    selectionChanged: () => void;
  };
}

export function getTelegram(): TelegramWebApp | null {
  return window.Telegram?.WebApp || null;
}

export function isTelegramWebApp(): boolean {
  const tg = getTelegram();
  return !!tg?.initData;
}

export function getTelegramUser() {
  const tg = getTelegram();
  return tg?.initDataUnsafe?.user || null;
}

export function getTelegramInitData(): string {
  const tg = getTelegram();
  return tg?.initData || '';
}

export function getStartParam(): string | null {
  const tg = getTelegram();
  return tg?.initDataUnsafe?.start_param || null;
}

export function initTelegramApp(): void {
  const tg = getTelegram();
  if (tg) {
    tg.ready();
    tg.expand();
  }
}

export function hapticFeedback(type: 'light' | 'medium' | 'heavy' | 'success' | 'error' | 'warning'): void {
  const tg = getTelegram();
  if (!tg) return;

  if (type === 'success' || type === 'error' || type === 'warning') {
    tg.HapticFeedback.notificationOccurred(type);
  } else {
    tg.HapticFeedback.impactOccurred(type);
  }
}

export function showMainButton(text: string, onClick: () => void): void {
  const tg = getTelegram();
  if (!tg) return;

  tg.MainButton.setText(text);
  tg.MainButton.onClick(onClick);
  tg.MainButton.show();
}

export function hideMainButton(): void {
  const tg = getTelegram();
  if (!tg) return;

  tg.MainButton.hide();
}
